//Only show permission checkbox if age < 16
ready().then(function() {
    let ageInput = $('#modal-review-form').find('#person_age');
    let iAgree = $('#modal-review-form').find('#iagree-label');

    iAgree.hide();

    ageInput.on('change keyup', function() {
        iAgree.find('input').prop('checked', true);
        iAgree.hide();

        if($(this).val() < 16) {
            iAgree.find('input').prop('checked', false);
            iAgree.show();
        }
    });


    const reviewFormInCustomOverlay = () => {
        const reviewFormButton = $('.review-form-link');
        const reviewForm = $('.section-review-form');
        const overlay = $('.overlay-default');
        const reviewFormOverlayCloseButton = $('.btn-close.overlay-close');

        reviewFormButton.on('click', function() {
            reviewForm.show().addClass('is-active');
            overlay.show();
        });

        reviewFormOverlayCloseButton.on('click', function() {
            reviewForm.hide().removeClass('is-active');
            overlay.hide();
        });

        overlay.on('click', function() {
            reviewForm.hide().removeClass('is-active');
            overlay.hide();
        });
    }
    reviewFormInCustomOverlay();
});
